import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import '../style/SettingsModal.css';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
  { code: 'es', label: 'ES' },
];

const SettingsModal = () => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <Modal title={t('settings.title')}>
      <div className="settings-modal">
        <div className="settings-modal-container">
          <div className="settings-section">
            <label className="settings-label">{t('settings.language')}</label>
            <div className="settings-language-options">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  className={`settings-language-btn ${i18n.language.startsWith(lang.code) ? 'active' : ''}`}
                  onClick={() => handleLanguageChange(lang.code)}
                >
                  {lang.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SettingsModal;
